import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { motion } from "motion-v";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";

interface Props {
    type?: ScrollAnimationType;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollAnimation',
  props: {
    type: { default: "fadeInSlideUp" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (!_ctx.type || _ctx.type === 'fadeInSlideUp')
    ? (_openBlock(), _createBlock(_unref(motion).div, {
        key: 0,
        initial: { opacity: 0, y: 20 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.6 }
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
}
}

})